<div>
  <h5>Password must contain:</h5>
  <ul class="list-unstyled fs-14">
    <li [ngClass]="{ 'valid': lengthValid, 'invalid': !lengthValid }">
      @if (lengthValid) {
        <i class="ri-check-line checkmark"></i>
      }
      @if (!lengthValid) {
        <i class="ri-close-line cross"></i>
      }
      Minimum <b>8 characters</b>
    </li>
    <li [ngClass]="{ 'valid': lowerCaseValid, 'invalid': !lowerCaseValid }">
      @if (lowerCaseValid) {
        <i class="ri-check-line checkmark"></i>
      }
      @if (!lowerCaseValid) {
        <i class="ri-close-line cross"></i>
      }
      At <b>lowercase</b> letter (a-z)
    </li>
    <li [ngClass]="{ 'valid': upperCaseValid, 'invalid': !upperCaseValid }">
      @if (upperCaseValid) {
        <i class="ri-check-line checkmark"></i>
      }
      @if (!upperCaseValid) {
        <i class="ri-close-line cross"></i>
      }
      At least <b>uppercase</b> letter (A-Z)
    </li>
    <li [ngClass]="{ 'valid': numberValid, 'invalid': !numberValid }">
      @if (numberValid) {
        <i class="ri-check-line checkmark"></i>
      }
      @if (!numberValid) {
        <i class="ri-close-line cross"></i>
      }
      A least <b>number</b> (0-9)
    </li>
  </ul>
</div>